import { useCallback, useMemo } from 'react'

import { getSigninSchema } from '@monorepo/validations/SigninSchema'
import { UserCredentialsType } from '@monorepo/deprecated/interfaces'
import { useUser } from './useUser'

type OptionsType = {
  email?: string
}

export function useSigninForm(options?: OptionsType) {
  const initialValues: UserCredentialsType = useMemo(
    () => ({
      username: options?.email ?? '',
      password: '',
    }),
    [options]
  )

  const { loginHandler } = useUser()

  const onSubmit = useCallback(
    async (credentails: UserCredentialsType) => {
      try {
        await loginHandler(credentails)
      } catch (error) {
        throw new Error('Неверный логин или пароль')
      }
    },
    [loginHandler]
  )

  const validationSchema = useMemo(() => getSigninSchema(), [])

  return { validationSchema, initialValues, onSubmit }
}
